{
  "general": {
    "title": "Error",
    "unknown": "An unexpected error occurred",
    "tryAgain": "Please try again later",
    "contactSupport": "If the problem persists, contact support"
  },
  "404": {
    "title": "Page Not Found",
    "message": "The page you're looking for doesn't exist",
    "action": "Go to Homepage"
  },
  "403": {
    "title": "Access Denied",
    "message": "You don't have permission to access this resource",
    "action": "Go Back"
  },
  "500": {
    "title": "Server Error",
    "message": "Something went wrong on our end",
    "action": "Refresh Page"
  },
  "network": {
    "title": "Network Error",
    "offline": "You appear to be offline",
    "slow": "Connection is slow",
    "timeout": "Request timed out",
    "retry": "Retry"
  },
  "auth": {
    "invalidCredentials": "Invalid email or password",
    "accountLocked": "Account has been locked",
    "sessionExpired": "Your session has expired",
    "unauthorized": "Please sign in to continue",
    "emailNotVerified": "Please verify your email address"
  },
  "validation": {
    "required": "This field is required",
    "email": "Please enter a valid email",
    "password": "Password must be at least 8 characters",
    "passwordMatch": "Passwords do not match",
    "terms": "You must accept the terms"
  },
  "api": {
    "requestFailed": "Request failed",
    "serverError": "Server error",
    "badRequest": "Invalid request",
    "notFound": "Resource not found",
    "conflict": "Resource conflict"
  }
}
